import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getCellColorMappingOptions } from 'api/cellColorMappings';
import { CellColorMapping } from 'interfaces/cellColorMapping';

export const useCellColorMappings = (
  params?: Omit<UseQueryOptions<CellColorMapping[], unknown, CellColorMapping[], string[]>, 'queryKey' | 'queryFn'>
) => useQuery(['cellColorMappings'], ({ signal }) => getCellColorMappingOptions(signal), params);
